module.exports = __webpack_public_path__ + "img/In.1d527553.svg";